import styled from 'styled-components/macro';

export const Container = styled.footer`
  position: absolute;
  display: flex;
  flex-direction: column;
  min-height: ${props => (props.isOpen ? '100%' : '0px')};
  transition: all 0.3s;
  width: 100%;
  bottom: 0;
  z-index: 12;
`;
